import { jsx as c } from "react/jsx-runtime";
function g(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var o = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var d;
function b() {
  return d || (d = 1, function(r) {
    (function() {
      var a = {}.hasOwnProperty;
      function i() {
        for (var t = "", n = 0; n < arguments.length; n++) {
          var e = arguments[n];
          e && (t = s(t, p.call(this, e)));
        }
        return t;
      }
      function p(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return i.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var n = "";
        for (var e in t)
          a.call(t, e) && t[e] && (n = s(n, this && this[e] || e));
        return n;
      }
      function s(t, n) {
        return n ? t ? t + " " + n : t + n : t;
      }
      r.exports ? (i.default = i, r.exports = i) : window.classNames = i;
    })();
  }(o)), o.exports;
}
var x = b();
const N = /* @__PURE__ */ g(x), m = {
  "purpur-link": "_purpur-link_1066f_1",
  "purpur-link--text": "_purpur-link--text_1066f_18",
  "purpur-link--standalone": "_purpur-link--standalone_1066f_18",
  "purpur-link--navigation": "_purpur-link--navigation_1066f_18",
  "purpur-link--disable-visited": "_purpur-link--disable-visited_1066f_29",
  "purpur-link--text-negative": "_purpur-link--text-negative_1066f_32",
  "purpur-link--standalone-negative": "_purpur-link--standalone-negative_1066f_32",
  "purpur-link--navigation-negative": "_purpur-link--navigation-negative_1066f_32",
  "purpur-link--ensure-target-area": "_purpur-link--ensure-target-area_1066f_71",
  "purpur-link--silent": "_purpur-link--silent_1066f_77"
}, h = N.bind(m), u = "purpur-link", y = {
  TEXT: "text",
  STANDALONE: "standalone",
  NAVIGATION: "navigation"
}, $ = Object.values(y), A = ({
  ["data-testid"]: r,
  children: a,
  className: i,
  disableVisited: p = !0,
  ensureTargetArea: s,
  href: t,
  negative: n = !1,
  onClick: e,
  rel: v,
  silent: l,
  target: k,
  variant: f,
  ..._
}) => (
  /* eslint-disable-next-line jsx-a11y/click-events-have-key-events */
  /* @__PURE__ */ c(
    "span",
    {
      className: h([
        i,
        u,
        `${u}--${n ? `${f}-negative` : f}`,
        {
          [`${u}--silent`]: l,
          [`${u}--negative`]: n,
          [`${u}--disable-visited`]: p ?? l,
          [`${u}--ensure-target-area`]: s
        }
      ]),
      "data-testid": r,
      onClick: t ? void 0 : e,
      ..._,
      children: t ? /* @__PURE__ */ c(
        "a",
        {
          href: t,
          target: k,
          rel: v,
          onClick: e,
          "data-testid": r ? `${r} a` : void 0,
          ..._,
          children: a
        }
      ) : a
    }
  )
);
A.displayName = "Link";
export {
  y as LINK_VARIANT,
  A as Link,
  $ as linkVariants
};
//# sourceMappingURL=link.es.js.map
